import ImagesIconsTypeActivityAskSvg from '@/public/images/icons/type-activity/ask.svg';
import ImagesIconsTypeActivityBidSvg from '@/public/images/icons/type-activity/bid.svg';
import ImagesIconsTypeActivityOrderSvg from '@/public/images/icons/type-activity/order.svg';

export {
  ImagesIconsTypeActivityAskSvg,
  ImagesIconsTypeActivityBidSvg,
  ImagesIconsTypeActivityOrderSvg,
};
